import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=204cb182&scoped=true&"
import script from "./stats.vue?vue&type=script&lang=js&"
export * from "./stats.vue?vue&type=script&lang=js&"
import style0 from "./stats.vue?vue&type=style&index=0&id=204cb182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204cb182",
  null
  
)

component.options.__file = "stats.vue"
export default component.exports